import { useEffect } from 'react';
import PageContainer from '../components/PageContainer';
import { useDispatch } from 'react-redux';
import AdviceCategorySection from '../components/AdviceCategorySection';
import HomepageWildSection from '../components/HomepageWildSection';
import HomepageOwnerSection from '../components/HomepageOwnerSection';
import ActivityIconSection from '../components/ActivityIconSection';
import RegionIconSection from '../components/RegionIconSection';
import ShopSection from '../components/ShopSection';
import { setWhichPage } from '../redux/searchbarSlice';
import Pool from '../components/poolBar/Pool';
import { useTranslation } from 'react-i18next';
import Hero from '../components/Hero';
import { setBacklink } from '../redux/backlinkSlice';
import DownloadAppSection from '../components/DownloadAppSection';
import { emptyFilters } from '../redux/filtersSlice';
import PartnerBrands from '../components/PartnerBrands';
import OutdoorAdvices from '../components/OutdoorAdvices';
import usePageTracking from '../hooks/usePageTracking';
import { Helmet } from 'react-helmet';

const HomePage = () => {

    const { pageTitle } = usePageTracking({
        pageTitle: "Ticino Wild"
    });

    const { t } = useTranslation();
    // Imposto AllActivities per la Pool
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setWhichPage('HomePage'));
        dispatch(setBacklink("/"));
        dispatch(emptyFilters())
    }, [dispatch])
    return (
        <PageContainer items="center">
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content="Sei pronto per la tua prossima avventura outdoor?" />
            </Helmet>
            <Pool />
            <Hero />

            {/* ICONS */}
            <div className='mt-8 mb-2 w-full lg:w-[1000px]'>
                <h1 className="text-[#225424]">{t('Homepage.chooseActivityTitle')}</h1>
            </div>

            {/* <ActivityTypeSection /> */}
            <ActivityIconSection />

            <AdviceCategorySection />

            <HomepageWildSection />

            <div className='mt-16 mb-2 w-full lg:w-[1000px]'>
                <h1 className="text-[#225424]">{t('Homepage.chooseYourRegionTitle')}</h1>
            </div>

            {/* <RegionSection /> */}
            <RegionIconSection />

            {/* Shop */}
            <ShopSection />

            {/* OutdoorAdvices */}
            <OutdoorAdvices />

            {/* Download app */}
            <DownloadAppSection />

            <HomepageOwnerSection />

            <div className='mt-16 mb-2 w-full lg:w-[1000px]'>
                <h1 className="text-[#225424]">{t('Homepage.ourPartnersTitle')}</h1>
            </div>
            <PartnerBrands />

        </PageContainer>
    )
}

export default HomePage;